import { escapeHtml } from '@vue/shared'
export default function queryParamRouteGuard(to) {
    const searchParams = new URLSearchParams(document.location.search)
    for (let [key, value] of searchParams.entries()) {
      to.query[key] = escapeHtml(value);
    }
}
